import { defineStore } from 'pinia'
import { useWsStore } from '@/stores/ws'

export const useWsSubsStore = defineStore('wsSubs', () => {

    const wsStore = useWsStore()
    
    function subCars(payload) {
        const msg = JSON.stringify(
            { 
                command: { 
                    object: { 
                        action: "add", 
                        Object: {
                            '@type': 'type.googleapis.com/carsPoints.SubArray',
                            carArray: payload.cars,
                            keyArray: payload.states
                        }
                    } 
                } 
            }
        )
        wsStore.sendMsg(msg)
    }

    function unsubCars(payload) {
        const msg = JSON.stringify(
            { 
                command: { 
                    object: { 
                        action: "add", 
                        Object: {
                            '@type': 'type.googleapis.com/carsPoints.UnsSubArray',
                            carArray: payload.cars
                        }
                    } 
                } 
            }
        )
        wsStore.sendMsg(msg)
    }

    return {
        subCars,
        unsubCars
    }
})
